import { user_managemnet_card } from "assets/images";
import useFullPageLoader from "common/UseFullPageLoader";
import React, { useEffect, useState } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { RiEdit2Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { childListApi } from "services/child";
import { formatToDDMMYYYY } from "utils/dateFormat";

const Babies = ({ userId }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [state, setState] = useState({
    list: []
  });

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await childListApi({ _user: userId });
      if (status === 200) {
        setState({ list: data?.data });
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      onHide();
    }
  }

  useEffect(() => {
    if (userId) {
      fetchData();
    }
  }, [userId]);

  return (
    <div className="cards_collection">
      {loader}
      <div className="row">
        {
          state?.list?.map((child) => {
            return <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="cards_parents">
                <div className="card_header_wrap">
                  <p>ID: {child?._child?.childId}</p>

                  <div className="card_icons">
                    {/* <Link>
                      <RiEdit2Line />
                    </Link> */}
                    <Link to={`/user-management/baby-detail/${child?._child?._id}`}>
                      <IoEyeOutline />
                    </Link>
                  </div>
                </div>

                <div className="card_images">
                  <img src={child?._child?.profilePicture?.length ? child?._child?.profilePicture : user_managemnet_card} />

                  <div className="cards_details">
                    <p>
                      <span>Name:</span>{child?._child?.fullName}
                    </p>
                    <p>
                      <span>DOB:</span>{formatToDDMMYYYY(child?._child?.dateOfBirth)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          })
        }
      </div>
    </div>
  );
};

export default Babies;
